module.exports = require("./fr-CM.js");